import { useEffect } from 'react';

import { useParams } from '@tanstack/react-router';

import { generateJsonLd, type IJsonLdData } from '../utils/generate-json-ld';
// import { casinoConfig } from './query-config.js';

interface IUseJsonLdRendererProps {
    jsonld?: IJsonLdData;
}

export function useJsonLdRenderer({ jsonld }: IUseJsonLdRendererProps) {
    const params: { lang?: string } = useParams({ strict: false });
    const locale = params.lang ?? 'en'; //TODO: read casinoConfig.defaultLanguage;

    useEffect(() => {
        const existingJsonLdScript = document.querySelector('script[type="application/ld+json"]');

        if (existingJsonLdScript) {
            existingJsonLdScript.parentNode?.removeChild(existingJsonLdScript);
        }

        const breadcrumbJsonLd = generateJsonLd({ breadcrumbs: jsonld?.breadcrumbs }, locale);

        const jsonLdArray = [breadcrumbJsonLd].filter(Boolean);
        if (jsonLdArray.length > 0) {
            const jsonLdScript = document.createElement('script');
            jsonLdScript.type = 'application/ld+json';
            jsonLdScript.textContent = `[${jsonLdArray.join(', ')}]`;
            document.head.appendChild(jsonLdScript);
        }
    }, [jsonld]);
}
